import "./pageSlider.scss";

import _ from "lodash";
import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";

import sliderTransitions, { DIRECTIVE_TRANSITIONS } from "../../constants/sliderTransitions";
import { PropTypeShapes } from "../../types";

class PageSlider extends PureComponent {
  constructor(props, context) {
    super(props, context);
    this.state = {
      slideForward: false,
      slideBackward: false,
      transition: sliderTransitions.NONE
    };
  }

  componentWillReceiveProps(nextProps) {
    let slideForward = false;
    let slideBackward = false;
    let transition = sliderTransitions.DEFAULT;
    let direction = null;
    if (nextProps.pageIndex > this.props.pageIndex) {
      slideForward = true;
      direction = sliderTransitions.FORWARD;
      transition = nextProps.transition ? nextProps.transition : sliderTransitions.DEFAULT;
    } else if (nextProps.pageIndex < this.props.pageIndex) {
      slideBackward = true;
      direction = sliderTransitions.BACKWARD;
      transition = this.props.transition ? this.props.transition : sliderTransitions.DEFAULT;
    } else {
      transition = nextProps.transition ? nextProps.transition : sliderTransitions.FADE;
    }

    this.setState({ slideForward, slideBackward, transition, direction });
  }

  render() {
    const makeItem = element => {
      return {
        element,
        pageIndex: this.props.pageIndex,
        pageId: this.props.pageId
      };
    };

    const items = _.isArray(this.props.children)
      ? _.map(this.props.children, c => makeItem(c))
      : [makeItem(this.props.children)];

    const transitionClass =
      this.state.direction && DIRECTIVE_TRANSITIONS.includes(this.state.transition)
        ? `${this.state.transition}-${this.state.direction}`
        : this.state.transition;

    return (
      <TransitionGroup className={`pageSlider ${transitionClass}`}>
        {items.map(item => (
          <CSSTransition key={item.pageId} timeout={550} classNames="sliderPage">
            <div key={item.pageId} className={`pageSliderPage`}>
              {item.element}
            </div>
          </CSSTransition>
        ))}
      </TransitionGroup>
    );
  }
}

PageSlider.propTypes = {
  children: PropTypeShapes.elementOrArray.isRequired,
  pageId: PropTypes.string.isRequired,
  pageIndex: PropTypes.number.isRequired,
  transition: PropTypes.string
};

export default PageSlider;
